import React from 'react';
import { FormattedMessage } from 'react-intl';
import { position, rem } from 'polished';
import styled from 'styled-components';

import { wrapWithStore } from 'helpers/store';
import { breakpoints } from 'helpers/styles/constants';
import { container } from 'helpers/styles/mixins';
import IconFirstStep from 'components/Icons/HowItWorks/IconFirstStep';
import IconLastStep from 'components/Icons/HowItWorks/IconLastStep';
import IconOnlineMeetings from 'components/Icons/HowItWorks/IconOnlineMeetings';
import { MainTitles, SubTitle, Title } from 'components/MainTitles/MainTitles';
import LandingApp from 'LandingApp';

import SectionItem from '../components/HowItWorks/SectionItem/SectionItem';

const Section = styled.div`
  position: relative;
  padding-left: ${rem(40)};

  @media ${breakpoints.smUp} {
    padding: 0 ${rem(80)};
  }

  @media ${breakpoints.mdUp} {
    padding: 0 ${rem(200)};
  }

  &::before {
    ${position('absolute', 0, null, 0, 0)};
    content: '';
    border-left: 2px dashed ${({ theme }) => theme.colors.main};
    opacity: 0.3;

    @media ${breakpoints.smUp} {
      left: ${rem(30)};
    }

    @media ${breakpoints.mdUp} {
      left: ${rem(100)};
    }
  }
`;

const Wrapper = styled.div`
  ${container()};
  margin-top: ${rem(60)};
  margin-bottom: ${rem(90)};

  @media ${breakpoints.smUp} {
    margin-top: ${rem(100)};
    margin-bottom: ${rem(140)};
  }
`;

function HowItWorksPage() {
  return (
    <LandingApp>
      <MainTitles>
        <Title>
          <FormattedMessage id="howItWorks.title" />
        </Title>

        <SubTitle>
          <FormattedMessage id="howItWorks.summary" />
        </SubTitle>
      </MainTitles>

      <Wrapper>
        <Section>
          <SectionItem icon={<IconFirstStep />} index={1} translationKey="howItWorks" />

          <SectionItem
            icon={<IconOnlineMeetings />}
            index={2}
            translationKey="howItWorks"
            hasSubtitle
          />

          <SectionItem icon={<IconLastStep />} index={3} translationKey="howItWorks" hasSubtitle />
        </Section>
      </Wrapper>
    </LandingApp>
  );
}

export default wrapWithStore(HowItWorksPage);
